<template>
   <div class="text-center">
      <div v-show="errorMsg">
         <p class="text-red-700 font-semibold text-lg">{{ errorMsg }}</p>
      </div>

      <div v-if="empty && !loading" class="py-32">
         <div v-if="isAdmin" class="text-center w-1/3 mx-auto">
            <p class="font-semibold text-gray-900 text-lg">Search by:</p>
            <!-- <span class="font-semibold text-gray-900 text-xs">For the moment you can search wm by tr_idtrans of wm.</span> -->
            <div class="mt-2">
               <label class="inline-flex items-center">
               <input v-model="searchByIdTrans" type="radio" class="form-radio" name="accountType" value="true">
               <span class="ml-2">id_trans</span>
               </label>
               <label class="inline-flex items-center ml-6">
               <input v-model="searchByIdTrans" type="radio" class="form-radio" name="accountType" value="false">
               <span class="ml-2">tr_numer</span>
               </label>
            </div>
            <form @submit.prevent="searchWm">
               <input
                  type="text"
                  v-model="wmNr"
                  class="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"/>
               <button class="bg-teal-400 text-white px-6 py-2 mx-1 rounded uppercase shadow-md hover:bg-teal-300 ">
               Search
               </button>
            </form>
         </div>
         <p class="py-4 font-semibold text-gray-900 text-lg">Choose AW:</p>
         <v-select
            @input="submit"
            class="text-center w-1/3 mx-auto"
            label="aw"
            :options="aws"
            v-model="aw"
            ></v-select>

         <!-- <p>{{ aw }}</p> -->
      </div>
      <div v-show="loading">
         <vue-loading
            type="spin"
            color="#4299e1"
            :size="{ width: '50px', height: '50px' }"
            ></vue-loading>
      </div>
  
      <div v-if="!empty" class>
         <div class="text-left mx-2">
            <form @submit.prevent="scanAW">
               <input
                  type="text"
                  ref="scan1"
                  v-model="scanId"
                  class="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  />
               <button
                  type="button" disabled
                  class="mx-2 bg-teal-400 py-1 rounded text-white px-4 shadow-md uppercase hover:bg-teal-300"
                  >
               Scan
               </button>
            </form>
         </div>
         <div class="text-left pt-10">
            <!-- <form @submit.prevent="scanWm"> -->
            <button @click="scanWm"
               type="button"
               class="mx-2 bg-teal-400 py-1 rounded text-white px-4 shadow-md uppercase hover:bg-teal-300"
               >
            Scan Wm
            </button>
            <!-- </form> -->
         </div>
         <div class="text-right">
            <button
               @click="redirect"
               class="bg-teal-400 text-white px-6 py-1 my-2 rounded uppercase shadow-md hover:bg-teal-300"
               >
            Back
            </button>
            <button
               @click="closeAw"
               class="text-right bg-teal-400 px-6 mx-1 py-1 text-white uppercase rounded hover:bg-teal-300"
               >
            close
            </button>
         </div>

         <div class="text-right">
            <a  target="_blank" :href="'https://api.homeface.de/aw-report/' + this.aw_id" 
               class="text-right bg-teal-400 px-6 mx-1 py-1 text-white uppercase rounded hover:bg-teal-300">
            EXPORT REPORT
            </a>
         </div>
         <div class="text-right py-2">
            <a  target="_blank" :href="'https://api.homeface.de/aw-report-excel/' + this.aw_id" 
               class="text-right bg-teal-400 px-6 mx-1 py-1 text-white uppercase rounded hover:bg-teal-300">
            EXPORT EXCEL REPORT
            </a>
         </div>

         <div class="text-right py-2">
            <a  target="_blank" :href="'https://api.homeface.de/aw-not-bz/' + this.aw_id" 
               class="text-right bg-teal-400 px-6 mx-1 py-1 text-white uppercase rounded hover:bg-teal-300">
            EXPORT REPORT AW NOT EQUAL
            </a>
         </div>
    
         <div class="text-right py-1">
            <button @click="refreshWm" class="text-right bg-teal-400 px-6 mx-1 py-1 text-white uppercase rounded hover:bg-teal-300">
            refresh wm
            </button>
         </div>
         <div class="text-right py-1">
            <button @click="updateEan" class="text-right bg-teal-400 px-6 mx-1 py-1 text-white uppercase rounded hover:bg-teal-300">
            Update Client EAN
            </button>
         </div>
         <div v-if="isAdmin" class="text-right py-1">
            <button @click="refreshAw" class="text-right bg-teal-400 px-6 mx-1 py-1 text-white uppercase rounded hover:bg-teal-300">
            refresh aw
            </button>
         </div>
         <div class="grid grid-cols-1 lg:grid-cols-3">
            <div
               v-for="aw in dataArray"
               :key="aw.id"
               class="rounded-lg m-2 py-10 border shadow-md"
               >
               <!-- ME FSHI , is_grabowski: is_grabowski NESE SBON SCAN AW -->
               <router-link class :to="{ name: 'wm', params: { tr_idtrans: aw.tr_idtrans, is_grabowski: is_grabowski } }">
                  <div class="cursor-pointer">
                     <span class="text-center font-semibold">{{ aw.tr_numer }} <br>
                     <span class="text-xs">{{ aw.tr_idtrans }}</span> 
                     </span> 
                  </div>
               </router-link>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
   import axios from "axios";
   import { VueLoading } from "vue-loading-template";
   
   export default {
     components: {
       VueLoading,
     },
     data() {
       return {
         loading: false,
         empty: true,
         aw: null,
         aws: [],
         errorMsg: "",
         scanId: "",
         dataArray: [],
         aw_id: 0,
         aw_number: null,
         isAdmin: false,
         wmNr: "",
         searchByIdTrans: false,
         // ME FSHI NESE NUK BON SCAN AW
         is_grabowski: ''
       };
     },
     created() {
       if (localStorage.getItem("wm-items")) {
         this.empty = false;
         this.dataArray = JSON.parse(localStorage.getItem("wm-items"));
       }
       this.getAws();
       this.getUser();
   
       if(!this.empty) {
         this.$nextTick(function () {
           this.$refs.scan1.focus();
         });
       }
       
       this.aw_id = JSON.parse(localStorage.getItem('aw-number'));
       this.aw_number = JSON.parse(localStorage.getItem('aw'))
       //ME FSHI NESE NUK BON SCAN AW
        if(this.aw_number != null)
       {
         this.isGrabowskiMethod(this.aw_id);
   
       }
     },
     methods: {
       getUser() {
         axios.defaults.headers.common["Authorization"] =
         "Bearer " + localStorage.getItem("access_token");
   
         axios.get(`${process.env.VUE_APP_API}/user`).then((response) => {
           // console.log(response);
           if (response.data.data.id === 1) {
             this.isAdmin = true;
           } else {
             this.isAdmin = false;
           }
         });
       },
   
       submit() {
         axios.defaults.headers.common["Authorization"] =
           "Bearer " + localStorage.getItem("access_token");
   
         this.loading = true;
         axios
           .post(`${process.env.VUE_APP_API}/aw`, {
             numer: this.aw.id,
             aw: this.aw.aw,
           })
           .then((response) => {
             this.dataArray = response.data;
   
             localStorage.setItem("wm-items", JSON.stringify(this.dataArray));
             localStorage.setItem('aw', JSON.stringify(this.aw.aw));
             localStorage.setItem('aw-number', JSON.stringify(this.aw.id));
   
             this.loading = false;
             this.empty = false;
             this.errorMsg = "";
           })
           .catch((error) => {
             if (error.response.status === 404) {
               this.errorMsg = "NO WM FOR THIS AW";
               this.empty = true;
             }
           })
           .finally(() => {
             this.loading = false;
             this.$nextTick(function () {
               this.$refs.scan1.focus();
             });
             this.aw_id = JSON.parse(localStorage.getItem('aw-number'));
             //ME FSHI NESE NUK BON SCAN AW
             this.isGrabowskiMethod(this.aw_id);
           });
       },
   
       searchWm() {
         axios.defaults.headers.common["Authorization"] =
           "Bearer " + localStorage.getItem("access_token");
         
         // console.log(this.searchByIdTrans);
         this.loading = true;
         axios.get(`${process.env.VUE_APP_API}/search-by-wm/${this.wmNr}/${this.searchByIdTrans}`)
           .then((response) => {
             // console.log(response.data);
   
             this.dataArray = response.data;
   
             localStorage.setItem("wm-items", JSON.stringify(this.dataArray));
             
             this.loading = false;
             this.empty = false;
             this.errorMsg = "";
           })
           .catch(error => {
             if (error.response.status === 404) {
               this.errorMsg = error.response.data;
               this.empty = true;
             }
           })
           .finally(() => {
             this.loading = false;
             this.$nextTick(function () {
               this.$refs.scan1.focus();
             });
           })
       },
   
       scanAW() {
         this.$router.push(`wm/${this.scanId}`);
       },
   
       scanWm() {
         axios.defaults.headers.common["Authorization"] =
           "Bearer " + localStorage.getItem("access_token");
         
         axios.get(`${process.env.VUE_APP_API}/wm_data/${this.aw_id}`)
           .then(() => {
             this.$router.push('/scan-wm');
           })
           .catch(error => console.log(error))
       },
   
       getAws() {
         axios.defaults.headers.common["Authorization"] =
           "Bearer " + localStorage.getItem("access_token");
   
         axios
           .get(`${process.env.VUE_APP_API}/aws`)
           .then((response) => {
             // console.log(response);
             this.aws = response.data;
   
           })
           .catch((error) => {
             console.log(error);
           });
       },
       // ME FSHI NESE NUK BON SCAN AW
       // ------------------------------------
   
       isGrabowskiMethod(aw_id) {
         axios.defaults.headers.common["Authorization"] =
           "Bearer " + localStorage.getItem("access_token");
         this.loading = true;
         axios
           .get(`${process.env.VUE_APP_API}/is_grabowski/${aw_id}`)
           .then((response) => {
             // console.log(response);
             // this.aws = response.data;
             this.is_grabowski = response.data[0].is_grabowski;
             console.log(this.is_grabowski);
             this.loading = false;
   
           })
           .catch((error) => {
             console.log(error);
           });
       },
   
       // -------------------------------------------------
   
       closeAw() {
         axios.post(`${process.env.VUE_APP_API}/close-aw`, {
           aw_id: JSON.parse(localStorage.getItem('aw-number')),
           aw_number: JSON.parse(localStorage.getItem('aw'))
         })
         .catch((error) => {
           console.log(error)
         })
         
         this.refreshWm();
   
         localStorage.removeItem("wm-items");
         localStorage.removeItem("aw");
         localStorage.removeItem("aw-number");
         location.reload();
       },
   
       updateEan() {
         axios.post(`${process.env.VUE_APP_API}/update-ean`)
           .then(() => {
             this.refreshWm();
           })
           .catch(error => {
             console.log(error)
           })
       },
   
       redirect() {
         this.refreshWm();
         location.reload();
       },
   
       refreshWm() {
         axios.post(`${process.env.VUE_APP_API}/refresh-wm`, {
           aw: this.aw_id,
           numer: JSON.parse(localStorage.getItem('aw')),
         }).then(() => {
             this.closeAw();
             this.redirect();
   
         }).catch((error) => {
           console.log(error)
         })
       },
   
       refreshAw() {
         axios.defaults.headers.common["Authorization"] =
           "Bearer " + localStorage.getItem("access_token");
         
         if (confirm("Are you sure?")) {
           axios.post(`${process.env.VUE_APP_API}/refresh-aw`, {
             numer: JSON.parse(localStorage.getItem('aw')),
           })
           .then(() => {
             // this.closeAw();      
           })
           .catch((error) => {
             console.log(error)
           })
   
           this.closeAw();      
         }
       }
     },
     
   };
</script>

<style>
</style>
